<div *ngIf="selectedQueryId$ | async; else empty">
  <div id="package-details-query-selected-view">
    <div id="query-selected-header">
      <div id="header-left">
        <hyperkit-typography variant="h4">
          {{ queryLogic()?.title }}
        </hyperkit-typography>
      </div>
      <div id="header-right">
        <hyperkit-button
          *ngIf="!isPivotQuery()"
          (click)="onPivot()"
          variant="standard"
          color="secondary"
          size="small"
          icon="shuffle"
          iconPosition="left"
          text="Pivot"
        ></hyperkit-button>
        <hyperkit-button-menu
          variant="standard"
          iconPosition="right"
          color="secondary"
          size="small"
          icon="chevron-down"
          (itemSelected)="handleMenuAction($event)"
          text="Mark As"
        >
          <hyperkit-dropdown-menu-item value="To Do" label="To Do" />
          <hyperkit-dropdown-menu-item value="Skip" label="Skip" />
          <hyperkit-dropdown-menu-item value="Run" label="Run" />
        </hyperkit-button-menu>
      </div>
    </div>

    <hyperkit-tab-bar [controlled]="true">
      <hyperkit-tab
        text="Overview"
        [selected]="ui.queryViewTab() === 'overview'"
        (tabClick)="ui.queryViewTab.set('overview')"
      />
      <hyperkit-tab
        text="Deployment Requirements"
        [selected]="ui.queryViewTab() === 'deployment'"
        (tabClick)="ui.queryViewTab.set('deployment')"
      />
      <hyperkit-tab
        text="Emulation and Validation"
        [selected]="ui.queryViewTab() === 'emulation'"
        (tabClick)="ui.queryViewTab.set('emulation')"
      />
    </hyperkit-tab-bar>

    <div class="tab-panel-content">
      <query-selected-overview-tab
        *ngIf="ui.queryViewTab() === 'overview'"
        [queryInstanceKey]="queryInstanceKey"
      />
      <query-selected-deployment-requirements-tab
        *ngIf="ui.queryViewTab() === 'deployment'"
      />
      <query-selected-emulation-validation-tab
        *ngIf="ui.queryViewTab() === 'emulation'"
      />
    </div>
  </div>
</div>

<ng-template #empty>
  <div style="color: red; padding: 1rem">No query selected</div>
</ng-template>
